import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { generateSearchFormItem, getTreeData } from "../../../../utils/helper";
import { SearchAccordion } from "../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({ filter, setFilter }: ISearchProps) => {
  const { t } = useTranslation();
  const T = (name: string) => {
    return t(`ConsumeRecord.${name}`);
  };

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "searchTime",
                },
                {
                  type: "text",
                  name: "id",
                  label: "id",
                },
                {
                  type: "text",
                  name: "playerID",
                  label: "playerID",
                },
                {
                  type: "text",
                  name: "product",
                  label: "product",
                },
                {
                  type: "multiSelect",
                  name: "type",
                  label: "type",
                  treeData: getTreeData(
                    ["Android", "IOS", "豪贈點消費", "鑽石消費"],
                    true
                  ),
                },
              ],
              defaultFilter(),
              T
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
